import { Box } from "@mui/material"
import type { ReactElement } from "react"

import DisplayAS400Id from "../common/DisplayAS400Id/DisplayAS400Id"

import { StatusIndicator } from "@/components/common/StatusIndicator/StatusIndicator"
import { ComputedProductStatus, type Product } from "@/graphql/codegen/graphql"
import { ComputedProductStatusMap } from "@/screens/Companies/products/utils/productStatusMap"

interface ProductStatusCellProps {
  product: Product
  "data-testid"?: string
}

export const ProductStatusCell = ({
  product,
  "data-testid": testId = "product-status",
}: ProductStatusCellProps): ReactElement => {
  return (
    <Box className='flex flex-col gap-1' data-testid={testId}>
      <Box className='flex items-center justify-start gap-2 px-1'>
        <StatusIndicator
          status={product.computedProductStatus ?? ComputedProductStatus.Inactive}
          map={ComputedProductStatusMap}
        />
        <div data-testid='public-id'>{product.publicId}</div>
      </Box>
      <Box>
        <DisplayAS400Id id={product.externalSystemId} />
      </Box>
    </Box>
  )
}
